module.exports = __webpack_public_path__ + "static/media/wprost.7761880e.png";